module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "glyphicon glyphicon-trash"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ece3e72","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TrashIcon.vue
// module id = 433
// module chunks = 1